function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 50 50"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39.58 0H10.42C4.66 0 0 4.66 0 10.42v29.17c0 5.75 4.66 10.42 10.42 10.42h29.17c5.75 0 10.42-4.66 10.42-10.42V10.42C50.01 4.67 45.35 0 39.59 0Zm-6.25 14.58h-4.01c-1.28 0-2.24.52-2.24 1.85v2.31h6.25l-.5 6.25h-5.75v16.67h-6.25V24.99h-4.17v-6.25h4.17v-4.01c0-4.21 2.22-6.41 7.21-6.41h5.29v6.25Z",
  "data-name": "Layer 1",
  style: {
    fill: "#102a56"
  }
}));
export default SvgFacebookIcon;